module.exports = __webpack_public_path__ + "static/3-insights-394e767ed12312f7386f1917ab28dfc7.jpg";